/**
 * Created by Carsten Bühler
 * User: CBuehler on 22.10.2015
 * Copyright: xdot GmbH 2015
 */

import {  AppContext, FormActions, RemoteDataActions } from 'plugin/liferay-widgets-react-web';
import { ClassNames, GROUP_NAMED_LISTS } from '../constants/Constants';
import NamedListWebApi from '../webapi/NamedListWebApi';

const className = ClassNames.AssetCategory;

export default {
    initialNamedLists: (query) => RemoteDataActions.list(GROUP_NAMED_LISTS, className, {}, NamedListWebApi.listViewableByGroupScope),
    list: (name, query) => RemoteDataActions.list(name, className, query, NamedListWebApi.listViewableByGroupScope),
    item: (name, query) => RemoteDataActions.item(name, className, query, NamedListWebApi.get),

    add: (item, formId, closeForm) => FormActions.submitForm(NamedListWebApi.add, item, formId, closeForm),
    update: (item, formId, closeForm) => FormActions.submitForm(NamedListWebApi.update, item, formId, closeForm),
    delete: (item, formId, closeForm) => FormActions.submitForm(NamedListWebApi.delete, item, formId, closeForm),
};



// WEBPACK FOOTER //
// ./js/actions/NamedListActions.js